export const config = {
  // Empty baseURL means "use the current origin". In dev, Vite's proxy
  // forwards /api/* to the FastAPI backend on http://localhost:8000; in
  // the production Docker image, nginx forwards /api/* to the backend
  // container. Hard-coding "http://localhost:8000" here breaks any
  // deployment that isn't running both processes on the same host
  // (Coolify, a remote dev box, an https reverse proxy, ...). Set
  // VITE_API_URL at build time only when the backend really lives on a
  // different origin than the SPA.
  apiUrl: import.meta.env.VITE_API_URL ?? '',
  appName: 'Vehicle Matching Admin Panel',
  version: '2.0.0',
} as const;

export default config;
